/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import classnames from 'classnames/bind';
import React from 'react';
import styles from './styles.sass';
import { FieldRadioToggleProps, FieldRadioToggleWithReduxProps } from './types';

const cx = classnames.bind(styles);

function FieldRadioToggle({
  label,
  name,
  options,
  isDisabled,
  onChange,
  value,
  cssProp,
}: FieldRadioToggleProps) {
  return (
    <fieldset css={cssProp}>
      {label && <legend className={styles.legend}>{label}</legend>}
      <div
        css={css`
          display: flex;
        `}
      >
        {options.map((option, index) => {
          const { value: optionValue, label: optionLabel } = option;
          const inputId = `${name}_${index}`;
          const lastIndex = options.length - 1;
          const isSelected = value === optionValue;
          return (
            <label
              key={`${optionValue}-radio-option`}
              htmlFor={inputId}
              data-cy={inputId}
              className={cx({
                option: true,
                firstOption: index === 0,
                lastOption: index === lastIndex,
                selected: isSelected,
                optionDisabled: isDisabled,
                selectedDisabled: isSelected && isDisabled,
              })}
            >
              {optionLabel}
              <input
                className={cx({
                  input: true,
                })}
                id={inputId}
                name={name}
                onChange={isDisabled ? () => null : () => onChange(optionValue)}
                value={optionValue}
                type="radio"
                checked={isSelected}
              />
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}

const FieldRadioToggleWithRedux = ({
  input: { name, onChange, value },
  label,
  options,
  isDisabled,
  cssProp,
}: FieldRadioToggleWithReduxProps) => (
  <FieldRadioToggle
    label={label}
    name={name}
    options={options}
    isDisabled={isDisabled}
    onChange={onChange}
    value={value}
    cssProp={cssProp}
  />
);

export { FieldRadioToggleWithRedux, FieldRadioToggle };
